import { formatDate } from './dates';
import { getStatusLabel, getSubscriptionStateLabel } from "./functions";

// Campos de suscripción que se toman del padre
const PARENT_SUBSCRIPTION_FIELDS = [
  'ki_subscription_uuid',
  'ki_subscription_name',
  'ki_subscription_state',
  'ki_connection_date',
  'renewal_date',
  'renewal_interval',
  'm2m_state',
  'm2m_hiring_date',
  'm2m_renewal_date',
  'm2m_renewal_interval',
];

// Formateadores de export para los campos que necesitan transformación
const EXPORT_FORMATTERS = {
  date:                  (r) => formatDate(r.date),
  ki_connection_date:    (r) => formatDate(r.ki_connection_date),
  expedition_date:       (r) => formatDate(r.expedition_date),
  state:                 (r, lang) => getStatusLabel(r.state, lang),
  ki_subscription_state: (r, lang) => getSubscriptionStateLabel(r.ki_subscription_state, lang),
};

// Ordena dos placas por fecha de asignación como repuesto (spare_date) ascendente.
// Desempate por ki_id ascendente. spare_date nulo se trata como el más antiguo.
export const compareBySpareDate = (a, b) => {
  const da = a.spare_date ? new Date(a.spare_date).getTime() : 0;
  const db = b.spare_date ? new Date(b.spare_date).getTime() : 0;
  if (da !== db) return da - db;
  return (a.ki_id ?? 0) - (b.ki_id ?? 0);
};

// Colapsa el árbol a UNA fila por equipo:
//   - sin repuestos → el propio padre
//   - con repuestos → último repuesto (spare_date más reciente) + suscripción del padre
export const collapseSpares = (roots) => {
  return roots.map((parent) => {
    const { children, ...parentRow } = parent;

    if (!children || children.length === 0) {
      return parentRow;
    }

    const sorted = [...children].sort(compareBySpareDate);
    const lastSpareRow = sorted[sorted.length - 1];

    const cleanSpare = { ...lastSpareRow };
    PARENT_SUBSCRIPTION_FIELDS.forEach((field) => {
      cleanSpare[field] = parentRow[field];
    });

    return cleanSpare;
  });
};

// Resuelve el valor de una columna por su dataIndex
// Para gestionar dataIndex anidados (Array) o simples (String)
const resolveCellValue = (row, dataIndex) => {
  const raw = Array.isArray(dataIndex)
    ? dataIndex.reduce((acc, key) => (acc == null ? acc : acc[key]), row)
    : row?.[dataIndex];
  return raw ?? '';
};

// Construye las filas del Excel a partir de la fuente (árbol) y las columnas visibles.
export function buildKiboxExportRows(sourceRows, visibleColumns, lang) {
  return collapseSpares(sourceRows).map((row) => {
    const obj = {};
    visibleColumns.forEach((col) => {
      const key = Array.isArray(col.dataIndex) ? col.dataIndex.join('.') : col.dataIndex;
      const fmt = EXPORT_FORMATTERS[key];
      obj[col.title] = fmt ? fmt(row, lang) : resolveCellValue(row, col.dataIndex);
    });
    return obj;
  });
}
